import React, { useState, useEffect } from "react";
import "./Navigation.css";

const services = [
  { label: "SharePoint Solutions", key: "sharepoint" },
  { label: "MS Dynamics 365", key: "dynamics" },
  { label: "Data Analytics", key: "analytics" },
  { label: "ReactJS Development", key: "reactjs" },
  { label: "AngularJS Development", key: "angularjs" },
  { label: ".Net Development", key: "dotnet" },
  { label: "Robotic Process Automation", key: "rpa" },
  { label: "Python Development", key: "python" },
];

const industries = [
  { label: "Construction", key: "construction" },
  { label: "Manufacturing", key: "manufacturing" },
  { label: "Govt. Firms", key: "govt" },
  { label: "Healthcare", key: "healthcare" },
  { label: "Oil & Gas", key: "oilgas" },
  { label: "Petrochemical", key: "petrochemical" },
  { label: "Retail", key: "retail" },
  { label: "Security Org.", key: "security" },
  { label: "E-Commerce", key: "ecommerce" },
  { label: "Transportation", key: "transportation" },
];

const navLinks = [
  { label: "Home", key: "home" },
  { label: "Services", key: "services", dropdown: services },
  { label: "Industries", key: "industries", dropdown: industries },
  { label: "Case Studies/Blogs", key: "case-studies" },
  { label: "About Us", key: "about" },
  { label: "Careers", key: "careers" },
  { label: "Contact Us", key: "contact" },
];

const Navigation = ({ isMobile }) => {
  const [open, setOpen] = useState(false);
  const [dropdown, setDropdown] = useState("");
  const [isTop, setIsTop] = useState(true);
  const [activeSection, setActiveSection] = useState("home"); // 🔑 track active

  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsTop(true);
      } else {
        setIsTop(false);
      }

      // Highlight section while scrolling
      const sections = [...navLinks, ...services, ...industries];
      for (let item of sections) {
        const section = document.getElementById(item.key);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(item.key);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Run once at mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Smooth scroll on click
  const handleNav = (key) => {
    setOpen(false);
    setDropdown("");
    setActiveSection(key); // update active on click

    const section = document.getElementById(key);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleDropdown = (key) => {
    setDropdown(dropdown === key ? "" : key);
  };

  return (
    <nav
      className={`navigation${isMobile ? " mobile" : ""} ${
        isTop ? "navigation_transparent" : ""
      }`}
    >
      <div
        className="nav-logo-company"
        style={{ display: "flex", alignItems: "center", gap: 12 }}
      >
        <div
          style={{
            width: 66,
            height: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src="/compnayLogo.png" alt="Technoserve Logo" />
        </div>
        <span
          style={{
            fontWeight: 400,
            fontSize: 16,
            color: "#fff",
            letterSpacing: 1,
          }}
        >
          Technoserve IT solutions
        </span>
      </div>

      {isMobile && (
        <div
          className="hamburger"
          onClick={() => setOpen(!open)}
          aria-label="Open menu"
          tabIndex={0}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}

      <ul
        className="animate-top-bounce ms-auto"
        style={
          isMobile
            ? { display: open ? "flex" : "none", flexDirection: "column" }
            : {}
        }
      >
        {navLinks.map((link) => (
          <li
            key={link.key}
            className={activeSection === link.key ? "active" : ""} // ✅ dynamic class
            style={{ position: "relative" }}
          >
            {link.dropdown ? (
              <>
                <span
                  onClick={() => handleDropdown(link.key)}
                  style={{ cursor: "pointer" }}
                >
                  {link.label}{" "}
                  <span
                    className="material-icons material-symbols-outlined"
                    style={{ fontWeight: "bold", verticalAlign: "middle" }}
                  >
                    {dropdown === link.key ? "expand_less" : "expand_more"}
                  </span>
                </span>

                <ul
                  className="dropdown"
                  style={{
                    display: dropdown === link.key ? "block" : "none",
                    position: isMobile ? "static" : "absolute",
                    background: "#fff",
                    color: "#002244",
                    minWidth: "180px",
                    boxShadow: isMobile ? "none" : "0 2px 8px rgba(0,0,0,0.07)",
                    zIndex: 200,
                    marginTop: isMobile ? 0 : 8,
                    left: 0,
                  }}
                >
                  {link.dropdown.map((item) => (
                    <li
                      key={item.key}
                      className={activeSection === item.key ? "active" : ""} // ✅ for dropdown items
                      onClick={() => handleNav(item.key)}
                      style={{ padding: "0.5rem 1rem", cursor: "pointer" }}
                    >
                      {item.label}
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <span onClick={() => handleNav(link.key)}>{link.label}</span>
            )}
          </li>
        ))}
        <li>
          <a
            href="https://itcubebpo.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            BPO/KPO
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
